import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("ferahis_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            localStorage.removeItem("ferahis_token");
            if (!window.location.pathname.startsWith("/giris")) {
                window.location.href = "/giris";
            }
        }
        return Promise.reject(err);
    },
);

export function formatApiError(detail) {
    if (detail == null) return "Bir hata oluştu. Lütfen tekrar deneyin.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export function formatMoney(n) {
    const val = Number(n || 0);
    return new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(val);
}

export function formatDate(iso) {
    if (!iso) return "-";
    try {
        return new Date(iso).toLocaleDateString("tr-TR", { year: "numeric", month: "2-digit", day: "2-digit" });
    } catch {
        return iso;
    }
}

export function formatDateTime(iso) {
    if (!iso) return "-";
    try {
        return new Date(iso).toLocaleString("tr-TR", { dateStyle: "short", timeStyle: "short" });
    } catch {
        return iso;
    }
}
